import React from 'react';
import PropTypes from 'prop-types';

import {TransilluminatorImage} from './TransilluminatorImage';
import {TransilluminatorTooltip} from './TransilluminatorTooltip';
import {TransilluminatorControls} from './TransilluminatorControls';

import {TransilluminatorControlsModal} from './TransilluminatorControlsModal';

import './style.scss';

export function Transilluminator(props) {

  const toggleShowTooltipControls = () => {
    props.toggleShowTooltipControls(!props.showTooltipControls)
  };

  const toggleIsOpen = () => {
    if(!props.showTooltipControls){
      toggleShowTooltipControls();
    }
    props.toggleLid(!props.open)
  };

  const toggleShowTransilluminatorControlsModal = () => {
    if(!props.showTooltipControls){
      toggleShowTooltipControls();
    }
    props.toggleShowTransilluminatorControlsModal(!props.showControlsModal)
  };

  return (
    <div className='transilluminator'>
      <TransilluminatorTooltip
        open={props.open}
        containsGel={props.containsGel}
        on={props.on}

        showControls={props.showTooltipControls}
        toggleShowTransilluminatorControlsModal={toggleShowTransilluminatorControlsModal}
        toggleLid={toggleIsOpen}
        onEjectGel={props.ejectGel}
      />
      <TransilluminatorControls
        open={props.open}
        containsGel={props.containsGel}
        toggleLid={toggleIsOpen}
        toggleShowTransilluminatorControlsModal={toggleShowTransilluminatorControlsModal}

        onInsertItem={props.onInsertItem}
      />
      <TransilluminatorImage
        open={props.open}
        containsGel={props.containsGel}
        on={props.on}
        onSelect={toggleShowTooltipControls}
      />

      <TransilluminatorControlsModal
        id={props.id}
        isOpen={props.showControlsModal}

        on={props.on}
        gelId={props.gelId}
        interactionProps={props.interactionProps}

        gelExamined = {props.gelExamined}
        gelOrientation = {props.gelOrientation}
        actualData = {{
          "id": 71,
          "type": "GEL_DRAG_DROP_QUESTION",
          "gelTheme": "DARK",
          "title": "Drag the DNA band on the gel below to the position you expect it to migrate through the gel.",
          "heading": "Predict the gel results:",
          "text": "With the knowledge of the size of the <i>TAS2R38</i> PCR product, where would you expect to see the band on the gel below? Use the DNA ladder, resolved alongside your sample, to judge the position of the band.",
          "gelRange": {
            "bottom": 40,
            "top": 500
          },
          "content": [
            "dragdrop"
          ],
          "gelTable": [
            {
              "colId": 0,
              "colType": "LABEL_COLUMN",
              "colItems": [
                {
                  "cellId": 0,
                  "cellType": "LABEL_CELL",
                  "label": ""
                },
                {
                  "cellId": 1,
                  "cellType": "GEL_HOLDER",
                  "cellItems": null,
                  "label": ""
                },
                {
                  "cellId": 2,
                  "cellType": "GEL_PATH",
                  "cellItems": [
                    {
                      "gelId": 0,
                      "gelType": "LABEL",
                      "height": 100,
                      "opacity": 1,
                      "value": 500,
                      "selected": false
                    },
                    {
                      "gelId": 1,
                      "gelType": "LABEL",
                      "height": 100,
                      "opacity": 1,
                      "value": 400,
                      "selected": false
                    },
                    {
                      "gelId": 2,
                      "gelType": "LABEL",
                      "height": 100,
                      "opacity": 1,
                      "value": 300,
                      "selected": false
                    },
                    {
                      "gelId": 3,
                      "gelType": "LABEL",
                      "height": 100,
                      "opacity": 0,
                      "value": 240,
                      "selected": false
                    },
                    {
                      "gelId": 4,
                      "gelType": "LABEL",
                      "height": 70,
                      "opacity": 1,
                      "value": 200,
                      "selected": false
                    },
                    {
                      "gelId": 5,
                      "gelType": "LABEL",
                      "height": 100,
                      "opacity": 1,
                      "value": 100,
                      "selected": false
                    },
                    {
                      "gelId": 6,
                      "gelType": "LABEL",
                      "height": 100,
                      "opacity": 0,
                      "value": 45,
                      "selected": false
                    }
                    
                  ]
                }
              ]
            }
          ]
        }}
        level = {props.level}

        onClose={toggleShowTransilluminatorControlsModal}
      />
    </div>
  );
}

Transilluminator.propTypes = {
  /**
   * Boolean to set if apparatus is open
   */
  isOpen: PropTypes.bool,
  /**
   * Boolean to set if digital contols modal should be displayed
   */
  showControlsModal: PropTypes.bool,
  /**
   * Boolean to set if tooltip controls should be displayed
   */
  showTooltipControls: PropTypes.bool,
  /**
   * Function to open/close the apparatus lid
   */
  toggleLid: PropTypes.func,
  /**
   * Function to open/close the digital controls modal
   */
  toggleShowControlsModal: PropTypes.func,
  /**
   * Function to open/close the tooltip controls menus
   */
  toggleShowTooltipControls: PropTypes.func,
  /**
   * Function to alert an event
   */
  alert: PropTypes.func,
};

Transilluminator.defaultProps = {};
